module.exports = __webpack_public_path__ + "img/hr-dry-tree-06.01750661.png";